module.exports = __webpack_public_path__ + "static/adjustable-bed-frame-1-video-thumbnail-21d4175a83c65597383bd79426f6b67b.webp";